<template>
  <a @click="handleTentative" class="button-primary block"><span>{{$t('tour_accept_tos')}}</span></a>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: {
    serviceArea: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      reservationDatetime: 'reservation/getDateTime'
    })
  },
  methods: {
    handleTentative: function () {
      const message = this.validate()
      if (message) {
        this.$alert({ message: message })
      } else {
        new Promise((resolve) => {
          this.$store.dispatch('reservation/tentative')
            .then((reservation) => {
              resolve(reservation)
            })
            .catch( () => {
              this.$store.dispatch('reservation/handleError')
            })
        })
      }
    },
    validate: function () {
      let message
      if (this.serviceArea.nextDayReservation) {
        message = this.validateWithNextDay()
      } else {
        message = this.validateWithThisDay()
      }
      return message
    },
    setMoment: function (time) {
      const a = time.split(':')
      return moment().set({ hour: a[0], minutes: a[1], second: a[2] })
    },
    validateWithThisDay: function () {
      let message
      const {
        startTime,
        endTime,
        operationStartTime,
        operationEndTime
      } = this.serviceArea.additional

      // 予約時刻と、現在時刻
      const target = this.reservationDatetime
      const client = moment()
      // 現在時刻検証用
      // const client = moment('2021/03/10 07:00:00')

      // 予約に指定できる最小時刻（営業開始時間）
      const targetMin = this.setMoment(operationStartTime)
      // 予約に指定できる最大時刻（営業終了時間）
      const targetMax = this.setMoment(operationEndTime)

      // 現在時刻の予約不可時刻（0時から予約受付開始時間）
      const clientZeroOclock = this.setMoment("00:00:00")
      const clientMin = this.setMoment(startTime)

      // 予約受付可能な最大時間
      const clientMax = this.setMoment(endTime)

      // 予約時刻が予約時刻を越えていないか、予約可能最小時刻より前かをチェック
      if (target.isAfter(targetMax) || target.isBefore(targetMin)) {
        message = this.$t('tour_alert_time_invalid')
      }
      // 予約時刻が不可能な時間帯ではないかチェック
      else if(client.isAfter(clientZeroOclock) && client.isBefore(clientMin)){
        message = this.clientErrorMessage()
      }
      // 予約受付可能時間を過ぎていないかチェック
      else if(client.isAfter(clientMax)){
        message = this.clientErrorMessage()
      }

      return message
    },
    clientErrorMessage: function () {
      const {
        startTime,
        endTime,
      } = this.serviceArea.additional

      const s = startTime && startTime.substring(0, 5)
      const e = endTime && endTime.substring(0, 5)

      return this.$t('tour_alert_hours_invalid', { start: s, end: e })
    },
    // 翌日予約用のバリデーション。東北MaaSでは利用していないが、ロジックを保持しておく。
    validateWithNextDay: function () {
      let message

      // 予約時刻と、現在時刻
      const target_datetime = this.$store.getters['reservation/getDateTime']
      const client_datetime = moment()

      // 本日分の最小時刻(当日8時)
      const today_min_target_datetime = moment().set({ hour: 8, minutes: 0, second: 0 })
      // 本日分の最大時刻(当日19時)
      const today_max_target_datetime = moment().set({ hour: 19, minutes: 0, second: 0 })
      // 予約時刻の翌日最小時刻(翌日8時)
      const next_day_min_target_datetime = moment().add(1, 'day').set({ hour: 8, minutes: 0, second: 0 })
      // 予約時刻の最大時刻(翌日12時)
      const next_day_max_target_datetime = moment().add(1, 'day').set({ hour: 12, minutes: 0, second: 0 })

      // 現在時刻の予約不可時刻(0時〜8時)
      const client_zero_oclock = moment().set({ hour: 0, minutes: 0, second: 0 })
      const client_eight_oclock = moment().set({ hour: 8, minutes: 0, second: 0 })
      // 当日分の最大時刻(18時)
      const client_eighteen_oclock = moment().set({ hour: 18, minutes: 0, second: 0 })

      // 1.予約時刻が翌日最大時刻を越えていないかチェック
      if (target_datetime.isAfter(next_day_max_target_datetime)) {
        message = this.$t('tour_alert_next_day_max_time')
      }
      // 2.予約時刻が当日最大時刻〜翌日最小時刻の間かをチェック
      else if (target_datetime.isAfter(today_max_target_datetime) && target_datetime.isBefore(next_day_min_target_datetime)) {
        message = this.$t('tour_alert_next_day_max_time')
      }
      // 3.予約時刻が当日最小時刻より前かをチェック
      else if (target_datetime.isBefore(today_min_target_datetime)) {
        message = this.$t('tour_alert_next_day_max_time')
      }
      // A.予約時刻が不可能な時間帯ではないかチェック
      else if(client_datetime.isAfter(client_zero_oclock) && client_datetime.isBefore(client_eight_oclock)){
        message = this.$t('tour_alert_reservation_time')
      }
      // B.当日予約であり、かつ、18時以降ではないかチェック
      else if(target_datetime.isBefore(today_max_target_datetime) && client_datetime.isAfter(client_eighteen_oclock)){
        message = this.$t('tour_alert_today_reservation')
      }

      return message
    }
  }
}
</script>
